export default "__VITE_ASSET__DOdzSGs2__"